import { CompanyRole } from '@interfaces/companyRole.interface';

import api from './';

export const { useGetCompanyRoleQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyRole: build.query<CompanyRole[], void>({
      query: () => ({ url: 'company-role' }),
    }),
  }),
});
